import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormGroup, NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

import { KeywordValue } from 'src/app/models/keyword';
import { KeywordAddFormFactory } from 'src/app/utils/factories/keywordAddFormFactory';
import { KeywordFormFactory } from 'src/app/utils/factories/keywordFormFactory';

@Component({
  selector: 'app-add-keyword-value',
  templateUrl: './add-keyword-value.component.html',
  styleUrl: './add-keyword-value.component.scss',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule
  ]
})
export class AddKeywordValueComponent implements OnInit {
  dialogRef = inject<MatDialogRef<AddKeywordValueComponent>>(MatDialogRef);
  data = inject<{
    value: KeywordValue | undefined;
    isNew: boolean;
  }>(MAT_DIALOG_DATA);

  keywordFormFactory = inject(KeywordFormFactory);
  keywordAddFormFactory = inject(KeywordAddFormFactory);
  formBuilder = inject(NonNullableFormBuilder);
  kwAddForm!: FormGroup;

  ngOnInit(): void {
    this.kwAddForm = this.keywordAddFormFactory.build(this.data.value);
  }

  save() {
    this.dialogRef.close(this.kwAddForm.getRawValue() as KeywordValue);
  }

  discard() {
    this.dialogRef.close();
  }
}
